import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import axios from "axios";
import * as moment from "moment";
import {connect}  from  "react-redux";

var yesterday = new Date(Date.now() - 24*60*60*1000);
class CrispReport extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray:[],
            daily_settl_time :'',
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });

        this.setState({
            reportPermissionsArray:reportPermissions,
            user_id:decoded._id
        });

    }

    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    render() {
        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                                <div className="header">
                                                    <h4 className="title">CRISP</h4>
                                                    <p className="category"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="content">
                                    <div className="row">
                                        {this.state.reportPermissionsArray.includes("crisp_merchant_kyc_status_report")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/link-pkyc-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Merchant KYC Status</h5>

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>: null }
                                        {this.state.reportPermissionsArray.includes("crisp_chargeback_report")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/crisp-chargeback-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Chargeback Report</h5>

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>: null }
                                        {this.state.reportPermissionsArray.includes("crisp_refund_report")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/crisp-refund-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Refund Report</h5>

                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>: null }

                                        {this.state.reportPermissionsArray.includes("crisp_business_volume_report")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/crisp-business-volume-report/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Business Volume Report</h5>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>: null }

                                            {this.state.reportPermissionsArray.includes("crisp_police_complaint_report")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/police-complaint-report/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Police Complaint Report</h5>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>: null }
                                            {this.state.reportPermissionsArray.includes("crisp_finance_report")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/finance-report/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Finance Report</h5>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>: null }
                                    </div>
                                    <div className="row">


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(CrispReport);